module.exports = __webpack_public_path__ + "static/media/budget.f7ec52ac.png";